module.exports = __webpack_public_path__ + "media/images/dmc/dmc_hero_img-32a30071e637df2f12dcad695d7ebcb4.jpg";